import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PostCodeAnywhereSearchEditor } from "../../../../../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { InstructionAddress } from "../../../../../../../Wrap/Models/Models/Instructions/InstructionAddress";
import { ContactOwnerType } from "../../../../../../../Wrap/Models/Models/Instructions/ContactOwnerType";
import { Address } from "../../../../../../../Wrap/Models/Domains/Address/Address";
import { IChildComponentProps } from "../../../../../../../react-core/Html/ChildComponent";
import { UkPostCode } from "../../../../../../../react-core/Html/Validation/RegExPatterns";

interface IFirmAddressProps extends IChildComponentProps<InstructionAddress> {
    instructionId: number;
    onRef: (v) => void;
    isReview?: boolean;
    notRequired?: boolean;
    OwnerType: ContactOwnerType;
}

interface IFirmAddressState {}

export class FirmAddress extends FormComponent<IFirmAddressProps, IFirmAddressState> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onAddressChange(changes) {
        let { data: address } = this.props;
        if (!address) {
            address = this.emptyAddress();
        }
        address.InstructionId = this.props.instructionId;
        for (const key in changes) {
            address[key] = changes[key];
        }
        this.props.onChange(address);
    }

    private onPostCodeSearchChange(v: Address) {
        const address: InstructionAddress = {
            InstructionId: this.props.instructionId,
            Line1: v.Line1,
            Line2: v.Line2,
            Line3: v.Line3,
            Line4: v.Line4,
            PostCode: v.Postcode,
            OwnerType: this.props.OwnerType,
        };
        this.props.onChange(address);
    }

    private emptyAddress() {
        return {
            InstructionId: this.props.instructionId,
            Line1: null,
            Line2: null,
            Line3: null,
            Line4: null,
            PostCode: null,
            OwnerType: this.props.OwnerType,
        };
    }

    render() {
        const { isReview } = this.props;
        const { data: address } = this.props;
        const required = !this.props.notRequired;
        return (
            <>
                <PostCodeAnywhereSearchEditor
                    onLookupError={() => {}}
                    useLabelForAddress
                    onAddressSelected={(v) => this.onPostCodeSearchChange(v)}
                    countryCode={CountryCode.GBR}
                    label="Post code"
                    disabled={isReview}
                />
                <br />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 1"
                    value={address?.Line1}
                    required={required ? "Please enter address line 1" : null}
                    onChange={(v) => this.onAddressChange({ Line1: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 2"
                    value={address?.Line2}
                    required={required ? "Please enter address line 2" : null}
                    onChange={(v) => this.onAddressChange({ Line2: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 3"
                    value={address?.Line3}
                    maxLength={35}
                    onChange={(v) => this.onAddressChange({ Line3: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Address line 4"
                    value={address?.Line4}
                    onChange={(v) => this.onAddressChange({ Line4: v })}
                />
                <TextBoxEditor
                    disabled={isReview}
                    label="Postcode"
                    value={address?.PostCode}
                    required={"Please enter postcode"}
                    regex={{ errorMessage: "Please enter valid postcode", value: UkPostCode }}
                    onChange={(v) => this.onAddressChange({ PostCode: v })}
                />
            </>
        );
    }
}
